

















import Vue from 'vue'
import QcqQualification from './QcqQualification.vue'
import QcqCompetence from './QcqCompetence.vue'
import QcqQuality from './QcqQuality.vue'
import { LOAD_MASTER_DATA_QCQ_QUALITY } from '@/store/action-types'
import { Quality } from '@/model/qcq/Quality'

interface ComponentData {
  activeTab: number
  qualityData: Quality | undefined
  isQualityEnabled: boolean
  isCompetencesQualityEnabled: boolean
  stars: number
}

export default Vue.extend({
  name: 'Qcq',

  components: {
    QcqQualification,
    QcqCompetence,
    QcqQuality
  },

  props: {
    employeeId: Number
  },

  data (): ComponentData {
    return {
      activeTab: 0,
      qualityData: undefined,
      isCompetencesQualityEnabled: false,
      isQualityEnabled: true,
      stars: 5
    }
  },

  computed: {},

  watch: {},

  methods: {},

  async mounted () {
    this.qualityData = await this.$store.dispatch(LOAD_MASTER_DATA_QCQ_QUALITY)
    if (this.qualityData && this.qualityData.employees) {
      this.isQualityEnabled = true
    } else {
      this.isQualityEnabled = false
    }

    if (this.qualityData && this.qualityData.competences) {
      this.isCompetencesQualityEnabled = true
    } else {
      this.isCompetencesQualityEnabled = false
    }

    if (this.qualityData && this.qualityData.numbersOfStars) {
      this.stars = this.qualityData.numbersOfStars
    }
  }

})
